import { render, staticRenderFns } from "./CampaignsListWrapper.vue?vue&type=template&id=53567b8a&"
import script from "./CampaignsListWrapper.vue?vue&type=script&lang=js&"
export * from "./CampaignsListWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports